<template>
  <va-card title="Rewarding Dog Training Links">
    <div class="links-container">
      <a href="https://forms.gle/druMA1f6GE7TC8fg7"
        alt="Dog Guardians Experience Survey"
        target="_blank"
        rel="noopener noreferrer"
        class="link"
        :style="{color: this.$themes.primary}" >
        <va-button style="width: 100%;">Dog Guardians Experience Survey</va-button>
      </a>
      <router-link to="/services/separation-anxiety" class="links">
        <va-button style="width: 100%;">
          Separation Anxiety
        </va-button>
      </router-link>
      <!-- <router-link to="/services" class="links">
        <va-button style="width: 100%;">
          Schedule a Session
        </va-button>
      </router-link> -->
      <a href="https://courses.malenademartini.com?aff=121"
        alt="Mission Possible Online Course"
        target="_blank"
        rel="noopener noreferrer"
        class="link"
        :style="{color: this.$themes.primary}" >
        <va-button style="width: 100%;">DIY: Mission Possible Online Course</va-button>
      </a>
      <a href="https://separationanxietydog.thinkific.com/courses/do-it-yourself-separation-anxiety-program?ref=c0c8d0"
        alt="Separation Anxiety Do it Yourself Program"
        target="_blank"
        rel="noopener noreferrer"
        class="link"
        :style="{color: this.$themes.primary}" >
        <va-button style="width: 100%;">DIY: Separation Anxiety Do it Yourself Program</va-button>
      </a>
      <router-link to="/" class="links">
        <va-button style="width: 100%;">
          Rewarding Dog Training Website
        </va-button>
      </router-link>
      <router-link to="/relaxation-protocol" class="links">
        <va-button style="width: 100%;">
          Relaxation Protocol
        </va-button>
      </router-link>
    </div>
  </va-card>
</template>

<script>

export default {
  name: 'quick-links-card',
}
</script>

<style scoped lang="scss">
  .links-container {
    a,
    .links {
      width: 100%;
    }
  }
</style>
